// GuestReviews.jsx
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./GuestReviews.css";
import unknown from "../img/images.jpeg";

// categories mapping (label shown in UI -> key inside ratings)
const CATEGORY_KEYS = [
  { label: "Staff", key: "staff" },
  { label: "Facilities", key: "facilities" },
  { label: "Cleanliness", key: "cleanliness" },
  { label: "Comfort", key: "comfort" },
  { label: "Value for money", key: "valueForMoney" },
  { label: "Location", key: "location" },
];

const ProgressBar = ({ value }) => (
  <div className="progress-bar" aria-hidden>
    <div
      className="progress-fill"
      style={{ width: `${Math.min(100, (value / 10) * 100)}%` }}
    />
  </div>
);

const truncate = (text, len = 150) =>
  text && text.length > len ? text.slice(0, len).trim() + "..." : text;

 const GuestReviews = ({property}) =>{
  const [reviews, setReviews] = useState([]);
  const [averages, setAverages] = useState({});
  const [overallAvg, setOverallAvg] = useState(0);
  const [openMap, setOpenMap] = useState({});

  useEffect(() => {


console.log(property)


if(property.vendorId){
  console.log(property.vendorId);

 fetch(`https://striking-dedication-production.up.railway.app/api/v1/public/reviews`, {
  method: "POST",
  headers: { 
    "Content-Type": "application/json" 
  },
  body: JSON.stringify({ vendorId: property.vendorId }),
})
  .then((res) => {
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return res.json();
  })
  .then((data) => {
    console.log(data)
    setReviews(data.data.reviews);
  })
  .catch((err) => console.error("Fetch error:", err));
 
}

  }, []);

  useEffect(() => {
    const approved = reviews.filter((r) => r.status === "approved");
    const n = approved.length || 0;
    const avgObj = {};
    CATEGORY_KEYS.forEach(({ label, key }) => {
      const sum = approved.reduce((s, r) => s + (r.ratings?.[key] || 0), 0);
      avgObj[label] = n ? +(sum / n).toFixed(1) : 0;
    });
    const overallSum = approved.reduce(
      (s, r) => s + (r.ratings?.overall || 0),
      0
    );
    setOverallAvg(n ? +(overallSum / n).toFixed(1) : 0);
    setAverages(avgObj);
  }, [reviews]);

  const toggleOpen = (id) => {
    setOpenMap((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  // slider settings
  const settings = {
    dots: true,
    infinite: reviews.filter((r) => r.status === "approved").length > 3,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="reviews-container">
      {/* Header */}
      <div className="reviews-header">
        <h2>Guest Reviews</h2>
        <button className="availability-btn">Read All Reviews</button>
      </div>

      {/* Score */}
      <div className="reviews-score" style={{ marginTop: 12 }}>
        <span className="score-badge">
          {overallAvg > 0 ? overallAvg : "-"}
        </span>
        <p style={{ margin: 0, color: "#555" }}>
          {overallAvg > 0 ? "Wonderful" : "No ratings yet"} · {reviews.length}{" "}
          reviews
        </p>
      </div>

      {/* Categories */}
      <div className="categories-grid" style={{ marginTop: 20 }}>
        {CATEGORY_KEYS.map(({ label }) => (
          <div key={label} className="category-item">
            <div className="category-header">
              <span>{label}</span>
              <span>{averages[label] ?? 0}</span>
            </div>
            <ProgressBar value={averages[label] ?? 0} />
          </div>
        ))}
      </div>

      <br />

      {/* Slider for Guest Cards */}
      <div className="guest-cards">
        <Slider {...settings}>
          {reviews
            .filter((r) => r.status === "approved")
            .map((rev) => (
              <div key={rev._id}>
                <div className="guest-card">
                  <div
                    className="guest-info"
                    style={{ display: "flex", flexDirection: "row" }}
                  >
                    <div style={{ paddingRight: 10 }}>
                      <img
                        src={unknown}
                        alt={rev.user?.fullName || "user"}
                        style={{ width: 48, height: 48, borderRadius: "50%" }}
                      />
                    </div>
                    <div>
                      <span className="guest-name">
                        {rev.user?.fullName || "Guest"}
                      </span>
                      <br />
                      <span className="guest-country">
                        {rev.property?.propertyName || ""}
                      </span>
                    </div>
                  </div>

                  <p className="guest-text" style={{ marginTop: 10 }}>
                    {openMap[rev._id] ? rev.review : truncate(rev.review, 140)}
                  </p>

                  <div style={{ marginTop: 8 }}>
                    <strong style={{ marginRight: 8 }}>Overall:</strong>
                    <span style={{ fontWeight: 700 }}>
                      {rev.ratings?.overall ?? "-"}
                    </span>
                    <div style={{ marginTop: 8 }}>
                      <ProgressBar value={rev.ratings?.overall ?? 0} />
                    </div>
                  </div>

                  <div style={{ marginTop: 10, fontSize: 13, color: "#444" }}>
                    {CATEGORY_KEYS.map(({ label, key }) => (
                      <div
                        key={key}
                        style={{
                          display: "inline-block",
                          marginRight: 12,
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>{label}:</span>{" "}
                        <span>{rev.ratings?.[key] ?? "-"}</span>
                      </div>
                    ))}
                  </div>

                  <div style={{ marginTop: 12 }}>
                    <button
                      className="read-more"
                      onClick={() => toggleOpen(rev._id)}
                    >
                      {openMap[rev._id] ? "Show less" : "Read more"}
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </div>
  );
}

export default  GuestReviews;